/*───────────────────────────────────────────────────────────────
 🌐 Project: Ring2All Platform
 🧑‍💻 Author: Rodrigo Cuadra
 🏢 Company: Ring2All LLC
 📄 File: utils/validators.ts (Queues)
 🗓️ Created: 2025-01-15
 🧩 Description:
    Form validation utilities for Queues module.

────────────────────────────────────────────────────────────────*/

import { FormState } from '../types';

/**
 * Validate Queue form
 */
export function validateForm(formData: FormState, t: (key: string) => string): Record<string, string> {
  const errors: Record<string, string> = {};
  const queueName = formData.queueName.trim();

  if (queueName.length === 0) {
    errors.queueName = t('queues.validation.nameRequired');
  }

  const maxWaitTime = Number(formData.maxWaitTime);
  if (!Number.isFinite(maxWaitTime) || maxWaitTime < 0) {
    errors.maxWaitTime = t('queues.validation.maxWaitTimeInvalid');
  }

  return errors;
}

